import request from '@/api/request'

export function login (data) {
  return request({
    url: 'webapi/user/login',
    method: 'post',
    data: data
  })
}

export function deviceLogin (data) {
  const req = {
    deviceImei: data.deviceImei,
    password: data.password
  }
  return request({
    url: 'webapi/user/deviceLogin',
    method: 'post',
    data: req
  })
}

export function experienceLogin () {
  const req = undefined
  return request({
    url: 'webapi/user/login/experience',
    method: 'post',
    data: req
  })
}

export function listUser (data) {
  return request({
    url: 'webapi/user/list',
    method: 'post',
    data: data
  })
}

export function exportUser (data) {
  return request({
    url: 'webapi/user/export',
    method: 'post',
    data: data,
    responseType: 'blob'
  })
}

export function listRoleName (data) {
  const req = {
    customerId: data.customerId
  }
  return request({
    url: 'webapi/user/listRoleName',
    method: 'post',
    data: req
  })
}

export function createUser (data) {
  const user = {
    userName: data.userName,
    password: data.password,
    email: data.email,
    mobile: data.mobile,
    sex: data.sex,
    customerId: data.customerId,
    userRole: data.userRole,
    deptId: data.deptId
  }
  return request({
    url: 'webapi/user/create',
    method: 'post',
    data: user
  })
}

export function updateUser (data) {
  const user = {
    userId: data.userId,
    username: data.username,
    password: data.password,
    email: data.email,
    mobile: data.mobile,
    sex: data.sex,
    status: data.status,
    customerId: data.customerId
  }
  return request({
    url: 'webapi/user/update',
    method: 'post',
    data: user
  })
}

export function deleteUser (id) {
  const delData = {
    userIds: id
  }
  return request({
    url: 'webapi/user/delete',
    method: 'post',
    data: delData
  })
}

export function getUserById (userId) {
  return request({
    url: 'webapi/user/getUserById/' + userId,
    method: 'get'
  })
}

export function changePassword (data) {
  const req = {
    userId: data.userId,
    oldPassword: data.oldPassword,
    newPassword: data.newPassword
  }
  return request({
    url: 'webapi/user/changePassword',
    method: 'post',
    data: req
  })
}

export function listLifeguard() {
  return request({
    url: 'webapi/user/listLifeguard',
    method: 'get'
  })
}

export function retrievePassword(data) {
  let req = {
    userName: data.userName,
    password: data.password,
    smsCode: data.smsCode
  }
  return request({
    url: 'webapi/user/retrievePassword',
    method: 'post',
    data: req
  })
}

export function resetPassword(data) {
  let req = {
    userId: data
  }
  return request({
    url: 'webapi/user/resetPassword',
    method: 'post',
    data: req
  })
}
